import { useMemo } from 'react'

import DeleteIcon from '@mui/icons-material/Delete'
import { Tooltip } from '@mui/material'
import { GridActionsCellItem } from '@mui/x-data-grid'
import { format, parseJSON } from 'date-fns'

import { IGridColumn } from 'components/common'
import { DATE_FORMAT } from 'constants/index'
import { usePermission } from 'providers'

interface IUseGetVehiclesColumnsProps {
  deletingVehicle: boolean
  handleDeleteVehicle: (id: string) => void
}

const useGetVehiclesColumns = ({
  deletingVehicle,

  handleDeleteVehicle,
}: IUseGetVehiclesColumnsProps) => {
  const [isAllowedToDeleteVehicle] = usePermission('DeleteVehicle')

  const columns: IGridColumn[] = useMemo(
    () => [
      { field: 'registrationNumber', headerName: 'Registration No', minWidth: 200, flex: 1 },
      {
        field: 'vehicleType',
        headerName: 'Vehicle Type',
        minWidth: 200,
        flex: 1,
        valueGetter: ({ value }) => value?.name,
        sortPath: ['vehicleType', 'name'],
      },
      { field: 'manufacturer', headerName: 'Manufacturer', minWidth: 200, flex: 1 },
      { field: 'model', headerName: 'Model', minWidth: 200, flex: 1 },
      {
        field: 'dateOfManufacture',
        headerName: 'Year',
        minWidth: 200,
        flex: 1,
        valueFormatter: ({ value }) => value && format(parseJSON(value as string), DATE_FORMAT),
      },
      { field: 'colour', headerName: 'Colour', minWidth: 200, flex: 1 },
      {
        field: 'actions',
        headerName: 'Actions',
        type: 'actions',
        minWidth: 100,
        getActions: ({ id }) => {
          return [
            <GridActionsCellItem
              key={id}
              label='Delete'
              size='large'
              disabled={deletingVehicle || !isAllowedToDeleteVehicle}
              onClick={() => handleDeleteVehicle(String(id))}
              icon={
                <Tooltip title={'Delete'} arrow>
                  <DeleteIcon />
                </Tooltip>
              }
            />,
          ]
        },
      },
    ],
    [deletingVehicle, handleDeleteVehicle, isAllowedToDeleteVehicle],
  )
  return columns
}
export default useGetVehiclesColumns
